export const SET_ANNOUNCEMENT_LIST = "@ANNOUNCEMENT/SET_LIST";
export const READ_ANNOUNCEMENT = "@ANNOUNCEMENT/READ";
export const APPEND_ANNOUNCEMENT = "@ANNOUNCEMENT/APPEND";
export const SET_ACKNOWLEDGED_ANNOUNCEMENT_IDS = "@ANNOUNCEMENT/SET_ACKNOWLEDGED_IDS";
